import { ParentContext } from 'global/cnr/contexts/ParentContext';
import UiSaveButtons from 'global/components/buttons/UiSaveButtons';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import _ from 'lodash';
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { seasonalDataHelpers, seasonalUpdateTypes } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalDataHelpers';
import { seasonalHelpers } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonalHelpers';
import { getLevelMatchez } from 'projectSpecific/sports/cnr/reducers/reducerHelpers/seasonSportsData';
import { _allowSportsUpdates, useSeasonalData } from 'projectSpecific/sports/useHelpers/useSeasonals';
import { _matchSeasonalCollection } from 'projectSpecific/sports/useHelpers/useSportRealtimeResults';
import React, { useContext, useEffect } from 'react'

export const MatchPendings = () => {

  const parentContext = useContext(ParentContext)
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainRt, mainDb } = app_state
  const { database_fns } = fns ?? {}

  // sportsDistrictContext
  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data, sportPermissions } = sportsDistrict_state ?? {}
  const { gls_scores } = district_data ?? {}
  const gls_score = gls_scores?.[pathViews?.sports]
  const { scoreEmails } = gls_score ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info, sportSettings_info, currentSeason_info } = sportsSeason_state ?? {};
  const { matchPlayoffPendings } = matches_info ?? {};
  const { useScoringCollection, useScoringCollectionOnly } = sportSettings_info ?? {}
  const { latestSeason, sportsKey } = currentSeason_info ?? {}

  const { updateSeasonalMatches_byLevel } = useSeasonalData()
  const { update_seasonalOrGlobal, getUpdateProps, getSports_collectionItem } = seasonalDataHelpers(mainDb, database_fns, pathViews)


  useEffect(() => {
    const cb = (res) => {
      // clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/_matches_seasonal/MVB_2026_YzZhvmotOHlY3ePS8QJj/playoffMatches/3A
      // clients/b4C6wHP0A5AgQPTD78ue/events/pojoSports/_matches_seasonal/MVB_2026_YzZhvmotOHlY3ePS8QJj/playoffMatches/2A
    }
    const pks = seasonalHelpers.getPks(pathViews, latestSeason, sportsKey, ['teams'])
    getSports_collectionItem(pks, '_matches_seasonal', true, null, cb)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { _levelUpdateMatches } = getLevelMatchez(matchPlayoffPendings)

  const handleUpdatePendings = () => {
    const cb = () => { }
    const _updateProps = {
      collectionName: _matchSeasonalCollection,
      forPlayoffs: true,
      pathViews,
      pks: seasonalHelpers.getPks(pathViews, latestSeason, sportsKey),
      seasonalUpdateType: seasonalUpdateTypes.matchesList,
      useScoringCollection,
      useScoringCollectionOnly,
      sportPermissions,
      dataToUpdate: _levelUpdateMatches,
      callback: cb
    }
    updateSeasonalMatches_byLevel(_updateProps)
  }

  const fnSub = (match) => {
    return <div>Some match info</div>
  }

  return <Wrapper
    content={<ItemMenuSquares menuItems={matchPlayoffPendings} imsType={_imsTypes.matchFull} fn_subContent={fnSub} />}
    footer={<UiSaveButtons
      save={{
        oc: handleUpdatePendings,
        color: _allowSportsUpdates.matches ? 'green' : 'teal',
        caption: 'Update Pending Matches'
      }}
    />}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ content: 'scoreboard' }}
  ></Wrapper>
}
